import ErrorConstants from '../constants/ErrorConstants';

/**
 * Tell the reducer to store the notice ID in the redux store.
 * @param  {object} error
 * @return {object]}
 */

function storeInternalError(error = {}) {
  return {
    type: ErrorConstants.STORE_INTERNAL_ERROR,
    payload: {
      error
    }
  };
}

function showErrorPage() {
  return {
    type: ErrorConstants.SHOW_ERROR_PAGE
  };
}

export default {
  showErrorPage,
  storeInternalError
};
